import { useTranslation } from '@frontend/i18n';
import { Text, TextAlignment, TextSize } from '@frontend/design-system';
import { IconWithText } from './icon-with-text';

type PrivateFieldProps = {
  isCompact?: boolean;
  textAlign?: TextAlignment;
  size?: TextSize;
};

export const PrivateField = ({ isCompact = true, textAlign = 'left', size = 'medium' }: PrivateFieldProps) => {
  const { t } = useTranslation('call-intel-core');
  return isCompact ? (
    <IconWithText text={t('Private')} icon='lock' size='medium' textColor='subdued' iconColor='subdued' />
  ) : (
    <Text color='subdued' size={size} textAlign={textAlign}>
      {t('This conversation is private and only visible to authorized users.')}
    </Text>
  );
};
